import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

export async function scheduleDailyStudyReminder(studyTime: string) {
  if (!Capacitor.isNativePlatform()) return false;
  const [hour, minute] = studyTime.split(':').map(Number);
  const perm = await LocalNotifications.checkPermissions();
  if (perm.display !== 'granted') {
    const requested = await LocalNotifications.requestPermissions();
    if (requested.display !== 'granted') return false;
  }
  await LocalNotifications.cancel({ notifications: [{ id: 365001 }] });
  await LocalNotifications.schedule({
    notifications: [{
      id: 365001,
      title: 'English Forge 365',
      body: 'Dars vaqti keldi. Ustoz kutmoqda — bugungi missiyani boshlang.',
      schedule: { on: { hour, minute }, repeats: true, allowWhileIdle: true },
      extra: { route: 'dashboard' },
    }],
  });
  return true;
}
